import type { AssetPath, UploadedAsset } from './types';

import { apiClient } from '~shared/api/createApiClient';

export const uploadAsset = (
  pharmacyId: string,
  file: File,
  assetPath: AssetPath = 'images'
): Promise<UploadedAsset> => {
  const formData = new FormData();

  formData.append('assetPath', assetPath);
  formData.append('file', file, file.name);

  return apiClient.post<UploadedAsset>('/api/assets', formData, { pharmacyId });
};
